import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot";
import axios from "axios";

export const getBrandListLookup = createAsyncThunk("/thunk/get-solarBrand-list", async () => {
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/utils/app/v1/get-solarBrand-list`);
    return response;
  } catch (error) {
    throw error;
  }
});

// get solar list api
export const getSolarListLookup = createAsyncThunk("/thunk/get-panel-list", async (formData) => {
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/utils/app/v1/get-panel-list`, formData);
    return response;
  } catch (error) {
    throw error;
  }
});
